import React from 'react';

export const QuestionIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 21, width = 21, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.25C16.4 1.25 20.75 5.6 20.75 11C20.75 16.4 16.4 20.75 11 20.75C5.6 20.75 1.25 16.4 1.25 11C1.25 5.6 5.6 1.25 11 1.25ZM11 0.5C5.225 0.5 0.5 5.225 0.5 11C0.5 16.775 5.225 21.5 11 21.5C16.775 21.5 21.5 16.775 21.5 11C21.5 5.225 16.775 0.5 11 0.5Z"
      fill="#2A2A2A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38808 7.00789C8.99636 7.32281 8.75 7.77882 8.75 8.375C8.75 8.58211 8.58211 8.75 8.375 8.75C8.16789 8.75 8 8.58211 8 8.375C8 7.54618 8.35364 6.87719 8.91817 6.42336C9.47489 5.97579 10.2188 5.75 11 5.75C11.7812 5.75 12.5251 5.97579 13.0818 6.42336C13.6464 6.87719 14 7.54618 14 8.375C14 9.52544 13.2665 10.1717 12.6516 10.7133C12.6212 10.7402 12.5909 10.7668 12.5611 10.7932C11.9078 11.3719 11.375 11.8919 11.375 12.875C11.375 13.0821 11.2071 13.25 11 13.25C10.7929 13.25 10.625 13.0821 10.625 12.875C10.625 11.5331 11.4047 10.8156 12.0639 10.2318C12.0731 10.2236 12.0822 10.2155 12.0914 10.2074C12.7591 9.61614 13.25 9.18146 13.25 8.375C13.25 7.77882 13.0036 7.32281 12.6119 7.00789C12.2124 6.68671 11.6438 6.5 11 6.5C10.3562 6.5 9.78761 6.68671 9.38808 7.00789Z"
      fill="black"
    />
    <path
      d="M11 16.25C11.4142 16.25 11.75 15.9142 11.75 15.5C11.75 15.0858 11.4142 14.75 11 14.75C10.5858 14.75 10.25 15.0858 10.25 15.5C10.25 15.9142 10.5858 16.25 11 16.25Z"
      fill="#2A2A2A"
    />
  </svg>
);
